import API from "./lib/api";
import { pointBasedUrl } from "./lib/url";


export const getAllPointBasedApi = async (restaurant_id, query) => {
    try {
        const { data } = await API.get( 
            `restaurant/${restaurant_id}${pointBasedUrl}?${query}`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}



export const addPointBasedApi = async (pointData) => {
    try {
        
        const response = await API.post( 
            `restaurant${pointBasedUrl}`,
            pointData
        );

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const editPointBasedApi = async (pointData, id) => {
    try {
        
        const { data } = await API.put( 
            `restaurant${pointBasedUrl}/${id}`,
            pointData
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}


export const singlePointBasedApi = async (id) => {
    try {
        
        const { data } = await API.get( 
            `restaurant${pointBasedUrl}/${id}`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}


export const deletePointBasedApi = async (id) => {
    try {
        
        const response = await API.delete(`restaurant${pointBasedUrl}/${id}`);

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const sendPointBasedCardApi = async (id, restaurant_id) => {
    try {
        const response = await API.post(
            `restaurant${pointBasedUrl}/${id}/send`,
            { restaurant_id }
        );

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}